import React, { useEffect, useState } from "react";
import { fetchProductAction } from "../../store/actions/setting.Action";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  ListItem,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import {
  CenteredBox,
  FilterTitleBox,
} from "../../components/layouts/OneViewBox";
import {
  CUSTOMER_TYPE,
  STATUS_COLOR_TYPE,
  STOCKLOG_STATUS,
  USER_ROLES,
} from "../../utils/constants";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import { fetchProductApi } from "../../apis/product.api";
import { StyledSearchBar } from "../../components/inputs/SearchBar";
import ClickButton from "../../components/button/ClickButton";
import CustomInput from "../../components/inputs/CustomInputs";
import moment from "moment";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { getSalesPersonApi } from "../../apis/salePerson.api";
import { getUserApi } from "../../apis/user.api";

const CustomerProductPurchaseUi = ({
  fields,
  setFields,
  setLoading,
  id,
  loading,
}) => {
  const [dataLoading, setDataLoading] = useState(true);

 useEffect(() => {
  if(!loading){
    const timeoutId = setTimeout(() => {
      setDataLoading(false)
    }, 1000);

    return () => clearTimeout(timeoutId);
  }

  }, [id,loading])

  
  return (
    <>
      <Box height={"100%"}>
        {dataLoading ? (
          <CenteredBox>
            <CircularProgress />
          </CenteredBox>
        ) : (
          <>
            <Box >
              <Typography variant="body2" color="red">
                {fields.err}
              </Typography>
            </Box>

            <Box>
              {/* <Box>
                <Typography variant="h3">Purchased Product :</Typography>
              </Box> */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  gap: 2,
                }}
              >
                <Box mt={2} width={"50%"}>
                  <AsyncDropDown
                    defaultVal={fields?.sold_details?.product?._id && {
                      _id: fields?.sold_details?.product?._id,
                      product_name: fields?.sold_details?.product?.product_name,
                    }}
                    lazyFun={async (para) =>
                      await fetchProductApi({ ...para, allStatus: true })
                    }
                    OptionComponent={({ option, ...rest }) => {
                      return (
                        <ListItem {...rest}>{option.product_name}</ListItem>
                      );
                    }}
                    // value={fields?.sold_details?.product ?? ""}
                    onChange={(changedVal) => {
                      console.log("this is changes value", changedVal);
                      setFields((prevFields) => ({
                        ...prevFields,
                        sold_details: {
                          ...prevFields.sold_details,
                          product: changedVal._id ? changedVal._id : [],
                        },
                        err: "",
                      }));
                    }}
                    titleKey={"product_name"}
                    valueKey={"_id"}
                    InputComponent={(params) => (
                      <StyledSearchBar
                        placeholder={"Select Product*"}
                        {...params}
                        margin="none"
                      />
                    )}
                  />
                </Box>

                <Box width={"50%"}>
                  <CustomInput
                    value={fields?.sold_details?.box_id || ""}
                    onChange={(e) =>
                      setFields({
                        ...fields,
                        sold_details: {
                          ...fields.sold_details,
                          ...fetchProductApi.sold_details,
                          box_id: e.target.value,
                        },
                      })
                    }
                    type="text"
                    label="Enter Box Id*"
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  gap: 2,
                }}
              >
                <Box width={"50%"}>
                  <CustomInput
                    disabled={loading}
                    value={fields?.sold_details?.amount}
                    onChange={(e) =>
                      setFields({
                        err: "",
                        ...fields,
                        sold_details: {
                          ...fields.sold_details,
                          amount: e.target.value,
                        },
                      })
                    }
                    type="text"
                    label={"Amount*"}
                  />
                </Box>

                <Box width={"50%"}>
                  <DesktopDatePicker
                    // sx={{ width: "18vw", height: "100%" }}
                    disableFuture
                    inputFormat="DD/MM/yyyy"
                    renderInput={(props) => <CustomInput {...props} />}
                    label={"Purchased Date"}
                    disabled={loading}
                    value={fields?.sold_details?.date}
                    onChange={(e) => {
                      setFields({
                        ...fields,
                        sold_details: {
                          ...fields.sold_details,
                          date: moment(e).toISOString(),
                        },
                      });
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </>
  );
};

export default CustomerProductPurchaseUi;
